import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATHS } from './paths';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import cn from 'classnames';
import { useThemeVars } from '@utils/hooks/use-theme-vars.ts';

interface Props {
  children: ReactNode;
}

export function PrivateRoute(props: Props) {
  const location = useLocation();
  const { vars, cls } = useThemeVars();

  if (!TokenExtension.get()?.string) {
    return <Navigate to={PATHS().LOGIN} state={{ from: location }} replace />;
  }

  return (
    <div className={cn('min-h-screen', cls.pageBg)} style={vars}>
      {props.children}
    </div>
  );
}

export function PublicRoute(props: Props) {
  const location = useLocation();
  const { vars, cls } = useThemeVars();

  if (TokenExtension.get()?.string) {
    return <Navigate to={PATHS().HOME} state={{ from: location }} replace />;
  }

  return (
    <div className={cn('min-h-screen', cls.pageBg)} style={vars}>
      {props.children}
    </div>
  );
}

export function SharedEditorRoute(props: Props) {
  const { vars, cls } = useThemeVars();

  return (
    <div className={cn('min-h-screen', cls.pageBg)} style={vars}>
      {props.children}
    </div>
  );
}
